export const NavigationPath = {
  ALL: "*",
  landing: "/",
  dashboard: "/dashboard",
  // Add other paths here
} as const;
